const locales = () => {
    return [
        {
            id: "en",
            name: "English",
        },
        {
            id: "pt",
            name: "Portuguese",
        },
        {
            id: "lt",
            name: "Lithuanian",
        },
        {
            id: "es",
            name: "Spanish",
        },
        {
            id: "ro",
            name: "Romanian",
        },
        {
            id: "fr",
            name: "French",
        },
    ];
};

export default locales;
